import { Application } from '@frontend/functionality/types';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export function getApplicationIcon(application: Application | 'my'): (props: { className?: string }) => React.JSX.Element {
    const icon = ICONS.APPLICATION[application];
    if (icon) {
        return icon;
    }
    return ICONS.APPLICATION['my'];
}

export function getApplicationDisplayName(application: Application | 'my'): React.ReactNode {
    switch (application) {
        case 'my':
            return (
                <FormattedMessage
                    id='license.application.my'
                    description='The name of the my application'
                    defaultMessage='My'
                />
            );
        case Application.ANALYTICS:
            return (
                <FormattedMessage
                    id='license.application.analytics'
                    description='The name of the analytics application'
                    defaultMessage='Analytics'
                />
            );
        case Application.AUTHORIZATION:
            return (
                <FormattedMessage
                    id='license.application.authorization'
                    description='The name of the authorization application'
                    defaultMessage='Authorization'
                />
            );
        case Application.CATALOGUE:
            return (
                <FormattedMessage
                    id='license.application.catalogue'
                    description='The name of the catalogue application'
                    defaultMessage='Catalogue'
                />
            );
        case Application.SPOTS:
            return CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS;
        case Application.LAUNDRY:
            return (
                <FormattedMessage
                    id='license.application.laundry'
                    description='The name of the laundry application'
                    defaultMessage='Laundry'
                />
            );
        case Application.PUDO:
            return (
                <FormattedMessage
                    id='license.application.pudo'
                    description='The name of the pudo application'
                    defaultMessage='PuDo'
                />
            );
        case Application.NIVALIZ:
            return (
                <FormattedMessage
                    id='license.application.nivaliz'
                    description='The name of the nivaliz application'
                    defaultMessage='Nivaliz'
                />
            );
        case Application.ORGANIZATION:
            return (
                <FormattedMessage
                    id='license.application.organization'
                    description='The name of the organization application'
                    defaultMessage='Organization'
                />
            );
        case Application.USERS:
            return (
                <FormattedMessage
                    id='license.application.users'
                    description='The name of the users application'
                    defaultMessage='Users'
                />
            );
        case Application.ADDRESS_BOOK:
            return (
                <FormattedMessage
                    id='license.application.address_book'
                    description='The name of the address book application'
                    defaultMessage='Address book'
                />
            );
        case Application.LENDING:
            return (
                <FormattedMessage
                    id='license.application.lending'
                    description='The name of the lending application'
                    defaultMessage='Lending'
                />
            );
        case Application.VENDING:
            return (
                <FormattedMessage
                    id='license.application.vending'
                    description='The name of the vending application'
                    defaultMessage='Vending'
                />
            );
        case Application.SHOP:
            return (
                <FormattedMessage
                    id='license.application.shop'
                    description='The name of the shop application'
                    defaultMessage='Shop'
                />
            );
        case Application.HARDWARE:
            return (
                <FormattedMessage
                    id='license.application.hardware'
                    description='The name of the hardware application'
                    defaultMessage='Hardware'
                />
            );
        case Application.MONITORING:
            return CommonMessage.LICENSES.MONITORING.DEFAULT;
        case Application.NOTIFICATIONS:
            return CommonMessage.OBJECTS.NOTIFICATION.PLURAL;
        case Application.CONSTRAINTS:
            return CommonMessage.OBJECTS.CONSTRAINT.PLURAL;
        case Application.REQUIREMENTS:
            return CommonMessage.OBJECTS.REQUIREMENT.PLURAL;
        case Application.BUDGETS:
            return CommonMessage.OBJECTS.BUDGET.PLURAL;
        default:
            return (application as string).replace(/_/g, ' ');
    }
}
